import React from 'react';
import Slider from 'react-slick'; // Import Slider component
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import './BoardMemberSlider.css'; // Your custom styles

// Updated placeholder data with 10 members
const boardMembersData = [
  {
    name: 'Max Mustermann',
    title: 'Treasurer',
    image: 'https://via.placeholder.com/200x250/transparent/003366?text=Max',
    bio: 'Max has been managing our finances with dedication for 5 years.'
  },
  {
    name: 'Erika Musterfrau',
    title: 'President',
    image: 'https://via.placeholder.com/200x250/transparent/0056b3?text=Erika',
    bio: 'Erika leads our club with passion and a clear vision for the future.'
  },
  {
    name: 'John Doe',
    title: 'Secretary',
    image: 'https://via.placeholder.com/200x250/transparent/d84315?text=John',
    bio: 'John ensures all our club communications and records are top-notch.'
  },
  {
    name: 'Anna Schmidt',
    title: 'Vice President',
    image: 'https://via.placeholder.com/200x250/transparent/1a237e?text=Anna',
    bio: 'Anna supports the president and oversees several key projects.'
  },
  {
    name: 'Peter Müller',
    title: 'Sports Director',
    image: 'https://via.placeholder.com/200x250/transparent/4caf50?text=Peter',
    bio: 'Peter is responsible for all athletic programs and development.'
  },
  {
    name: 'Sophie Wagner',
    title: 'Youth Coordinator',
    image: 'https://via.placeholder.com/200x250/transparent/ff9800?text=Sophie',
    bio: 'Sophie is passionate about engaging young members in club activities.'
  },
  {
    name: 'Klaus Weber',
    title: 'Events Manager',
    image: 'https://via.placeholder.com/200x250/transparent/f44336?text=Klaus',
    bio: 'Klaus organizes our memorable club events throughout the year.'
  },
  {
    name: 'Julia Becker',
    title: 'Public Relations',
    image: 'https://via.placeholder.com/200x250/transparent/9c27b0?text=Julia',
    bio: 'Julia manages our external communications and media presence.'
  },
  {
    name: 'Markus Fischer',
    title: 'Facility Manager',
    image: 'https://via.placeholder.com/200x250/transparent/795548?text=Markus',
    bio: 'Markus keeps our club facilities in top condition for all members.'
  },
  {
    name: 'Laura König',
    title: 'Member Services',
    image: 'https://via.placeholder.com/200x250/transparent/607d8b?text=Laura',
    bio: 'Laura is the first point of contact for member inquiries and support.'
  }
];

const BoardMembersSlider = () => {
  const settings = {
    dots: true, // Show dots for navigation
    infinite: boardMembersData.length > 3, // Loop slides if enough members
    speed: 500, // Animation speed
    slidesToShow: 3, // Number of slides to show at once on larger screens
    slidesToScroll: 1, // Number of slides to scroll at once
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    arrows: true, // Show prev/next arrows
    responsive: [
      {
        breakpoint: 1024, // Medium devices (tablets)
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: boardMembersData.length > 2,
          dots: true
        }
      },
      {
        breakpoint: 768, // Small devices (large phones, small tablets)
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false, // Hide arrows on smaller screens for more space
          dots: true,
          infinite: boardMembersData.length > 1,
        }
      }
    ]
  };

  return (
    <div className="board-members-slider-container">
      <h2 className="section-title text-center">Unser Vorstand</h2>
      <p className="section-subtitle text-center">
        Lernen Sie die Menschen kennen, die unseren Verein leiten und gestalten.
      </p>
      
      <div className="slider-wrapper"> {/* Keep this wrapper for overall padding/margin if needed, or apply to Slider directly */}
        <Slider {...settings}>
          {boardMembersData.map((member, index) => (
            <div key={index} className="member-slide"> {/* react-slick will add its own classes here */}
              <div className="member-card">
                <div className="member-image-wrapper">
                  <img src={member.image} alt={`${member.name}, ${member.title}`} className="member-image" />
                </div>
                <div className="member-info">
                  <h3 className="member-name">{member.name}</h3>
                  <p className="member-title">{member.title}</p>
                  {member.bio && <p className="member-bio">{member.bio}</p>}
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
      {/* Removed the placeholder paragraph about dynamic slider */}
    </div>
  );
};

export default BoardMembersSlider;